// Copyright ©️ 2026 eVolve MEP, LLC

import type { BenderProfile, ConduitSizeId, ConduitTypeId } from '@evolvemep/api-ts';

export const extractConduitTypes = ({ configurationValues }: BenderProfile): ConduitTypeId[] => [
  ...new Set(configurationValues.map((config) => config.conduitType.conduitTypeId)),
];
export const extractConduitSizes = (
  { configurationValues }: BenderProfile,
  conduitTypeId: ConduitTypeId,
): ConduitSizeId[] => [
  ...new Set(
    configurationValues
      .filter((config) => config.conduitType.conduitTypeId === conduitTypeId)
      .map((config) => config.conduitSize.conduitSizeId),
  ),
];
